import(/* webpackMode: "eager" */ "/vercel/path0/app/documentation/page.tsx");
